// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control:disabled, .form-control[readonly] {
  background-color: lightgray !important;
  opacity: 1;
}

.form-control {
  width: -moz-fit-content;
  width: fit-content;
  min-width: 250px;
  margin: 0 0 0 11px;
}

.form-select {
  margin-left: 10px !important;
}

.primary {
  margin: 0 0 0 10px !important;
}

.selector-form {
  text-align: center;
  display: flex;
  color: #8C8C8C;
  position: relative;
  float: left;
  height: 41px;
  width: 100%;
  margin-top: 2px;
}

.label {
  margin-right: 11px;
  color: var(--theme-active-color, #243391);
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.305883px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 60px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
